import { render, staticRenderFns } from "./ImageWithGradientOverlay.vue?vue&type=template&id=1010deb2&scoped=true&"
import script from "./ImageWithGradientOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageWithGradientOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithGradientOverlay.vue?vue&type=style&index=0&id=1010deb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010deb2",
  null
  
)

export default component.exports